import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import DrilldownTableSS from '../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { getSmsMessageLogSelector } from '../../../../../../redux/reducers/reducerSlices/SmsMessageLogReducer';
import { formatDate_MM_DD_YYYY } from '../../../../../Assests/Utility';
import TinyLoader from '../../../../Common/TinyLoader/TinyLoader';
import DatePickerSS from '../../../../DatePickerSS/DatePickerSS';
import { AppConstant } from '../../../../../Assests/AppConstant';
import CustomDropDown from '../../../../Common/CustomDropDown/CustomDropDown';
import './SmsMessageLog.css';
import moment from 'moment';
import { CustomPaginationSS } from '../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { getRemoteConfigSelector } from '../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import WarehouseSearch from '../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearch';
const SmsMessageLog = ({ themeSelected = 'light-mode' }) => {
    const dispatch = useDispatch();
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration || {};

    const { isLoading, smsLogs } = useSelector(getSmsMessageLogSelector);
    const [logsData, setLogsData] = useState({});
    const [logsDataArr, setLogsDataArr] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchStr, setSearchStr] = useState('');
    const [showStartDate, setShowStartDate] = useState(false);
    const [showEndDate, setShowEndDate] = useState(false);
    const [maxEndDate, setMaxEndDate] = useState(new Date());
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState({ name: 'All' });
    const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);

    const titleDD = [
        { id: 'phoneNumber', name: 'PhoneNumber' },
        { id: 'poNumber', name: 'PO Number' },
        { id: 'messageText', name: 'MessageText' },
        { id: 'provider', name: 'Provider' },
        // { id: 'messageActionType', name: 'MessageActionType' },
        { id: 'sendStatus', name: 'SendStatus' },
        { id: 'sendTimestamp', name: 'SendTimestamp' },
        { id: 'deliveryTimestamp', name: 'DeliveryTimestamp' },
        { id: 'failureReason', name: 'FailureReason' },
        // { id: 'retryCount', name: 'RetryCount' },
        { id: 'sourceApp', name: 'SourceApp' },
        // { id: 'type', name: 'Type' },
    ];

    const formatListDataDrillDown = (data) => {
        return (data || []).map((el) => ({
            0: el.PhoneNumber || '-',
            1: el.poNumber || '-',
            2: el.MessageText || '-',
            3: el.Provider || '-',
            // 3: el.MessageActionType || '-',
            4: el.SendStatus || '-',
            5: el.SendTimestamp ? `${moment(el.SendTimestamp).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.SendTimestamp).format(AppConstant.commonStrings.HH_mm_dateFormat)}` : AppConstant.commonStrings.hypen,
            6: el.UpdatedAt ? `${moment(el.UpdatedAt).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.UpdatedAt).format(AppConstant.commonStrings.HH_mm_dateFormat)}` : AppConstant.commonStrings.hypen,
            7: el.FailureReason || '-',
            // 7: el.RetryCount || '-',
            8: el.SourceApp || '-',
            // 10: el.Type || '-',
        }));
    };

    const getBodyData = () => formatListDataDrillDown(logsData?.Items);

    const fetchData = (pageNo = 1, limit = 20) => {
        // if (isLoading || loading) return;
        let phoneNumber = searchStr;
        if (phoneNumber && /^\d{10}$/.test(phoneNumber)) {
            phoneNumber = `+1${phoneNumber}`;
        }
        const params = {
            "currentPage": pageNo,
            "itemsPerPage": limit,
            status: selectedStatus.name,
            startDate: moment(selectedStartDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            endDate: moment(selectedEndDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            phoneNumber: phoneNumber,
            lastEvaluatedKey: lastEvaluatedKey,
        };

        dispatch({ type: sagaActions.GET_SMS_MESSAGE_LOG, payload: params });
    };

    const handleStartDate = (date) => {
        let threeMonthslater = new Date(date);
        threeMonthslater.setMonth(date.getMonth() + 3);
        if (threeMonthslater < selectedEndDate) {
            setSelectedEndDate(null);
        }
        setSelectedStartDate(date);
        getMaxEndDate(date);
    };

    const getMaxEndDate = (startDate) => {
        let currentDate = new Date();
        let threeMonthslater = new Date(startDate);
        threeMonthslater.setMonth(startDate.getMonth() + 3);
        threeMonthslater.setDate(threeMonthslater.getDate() - 1);
        if (currentDate <= threeMonthslater) {
            setMaxEndDate(currentDate);
        } else {
            setMaxEndDate(threeMonthslater);
        }
    };

    const showStatusDropDown = () => {
        const statusFilterData = [
            { name: "All" },
            { name: "Sent" },
            { name: "Failed" },
            { name: "Delivered" },
            { name: "Pending" },
        ];
        return (
            <div className="d-flex align-items-center">
                <div className="me-2 titleFiltersLeaveMeta">
                    Status:
                </div>
                <CustomDropDown
                    themeSelected={themeSelected}
                    data={statusFilterData}
                    placeHolder={selectedStatus.name}
                    onSelect={(event) => setSelectedStatus(event)}
                    keyStr={"name"}
                />
            </div>
        );
    }

    useEffect(() => {
        dispatch({ type: sagaActions.CLEAR_SMS_MESSAGE_LOG });
        const dStart = new Date();
        dStart.setHours(0, 0, 0, 0);
        const dEnd = new Date();
        dEnd.setHours(23, 59, 59, 0);
        setSelectedStartDate(dStart);
        setSelectedEndDate(dEnd);
        return () => {
            dispatch({ type: sagaActions.CLEAR_SMS_MESSAGE_LOG });
        };
    }, [dispatch]);

    useEffect(() => {
        setLogsData({ Items: [] });
        if (smsLogs && smsLogs?.Items) {
            let items = _.orderBy(smsLogs?.Items, ['SendTimestamp'], ['desc']);
            setLogsData({ ...smsLogs, Items: items });
            setLastEvaluatedKey(smsLogs.lastEvaluatedKey);
        } else {
            setLogsData({ Items: [] });
        }
        setLoading(false);
    }, [smsLogs]);

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            fetchData();
        }
    }, [selectedStartDate, selectedEndDate, selectedStatus]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchStr === null) return;
            if (searchStr?.length === 0 || searchStr?.length > 3) {
                fetchData();
            }
        }, 500); // 500ms debounce time

        return () => {
            clearTimeout(handler);
        };
    }, [searchStr]);


    const pageChange = (pageNo, limit) => {
        fetchData(pageNo, limit)
    }

    return (
        <div className="pt-2">
            <div className="container-fluid d-flex justify-content-between align-items-center py-2">
                <h4 className="m-0">Message Logs</h4>
                <div className="d-flex appt-report-header gap-3 align-items-center">
                    <div className="pos-rel">
                        <div className="d-flex flex-column align-items-start">
                            <label className="boldText m-0 f-14">
                                <i className="fa-regular fa-calendar"></i> Start Date{" "}
                            </label>
                            <button
                                className={"datePickerBtn h-100 w-100"}
                                onClick={() => setShowStartDate(!showStartDate)}
                                disabled={false}
                            >
                                <span className="btn-title">
                                    {selectedStartDate
                                        ? formatDate_MM_DD_YYYY(selectedStartDate)
                                        : "Start Date"}
                                </span>
                                <i
                                    className="fa-regular fa-calendar"
                                    style={{ marginInline: "9px" }}
                                ></i>
                            </button>
                            {showStartDate && (
                                <div className="appt-summary-ss-datePicker csce-ss-datePicker">
                                    <DatePickerSS
                                        maxDate={new Date()}
                                        setSelectedDate={handleStartDate}
                                        selectedDate={selectedStartDate}
                                        closeCalendar={() => {
                                            setShowStartDate(!showStartDate);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="pos-rel">
                        <div className="d-flex flex-column align-items-start">
                            <label className="boldText m-0 f-14">
                                <i className="fa-regular fa-calendar"></i> End Date{" "}
                            </label>
                            <button
                                className={"datePickerBtn h-100 w-100"}
                                onClick={() => setShowEndDate(!showEndDate)}
                                disabled={false}
                            >
                                <span className="btn-title">
                                    {selectedEndDate
                                        ? formatDate_MM_DD_YYYY(selectedEndDate)
                                        : "End Date"}
                                </span>
                                <i
                                    className="fa-regular fa-calendar"
                                    style={{ marginInline: "9px" }}
                                ></i>
                            </button>
                            {showEndDate && (
                                <div className="appt-summary-ss-datePicker">
                                    <DatePickerSS
                                        setSelectedDate={setSelectedEndDate}
                                        minDate={new Date(selectedStartDate)}
                                        maxDate={maxEndDate}
                                        selectedDate={selectedEndDate}
                                        closeCalendar={() => {
                                            setShowEndDate(!showEndDate);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-3">{showStatusDropDown()}</div>
                    <div className="mt-3">
                        <WarehouseSearch
                            inputValue={searchStr}
                            onChangeHandler={setSearchStr}
                            cancelSearch={() => {
                                setSearchStr('');
                            }}
                            placeholder={'Search Phone Number'}
                        />
                    </div>
                </div>
            </div>

            <div className="sms-log-container-new mt-1">
                <DrilldownTableSS
                    key={Math.random()}
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={titleDD}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    hasCollapsableContent={false}
                    collapsableData={[]}
                    accordionPrimaryIndex={1}
                    drillDownReport={logsData?.Items}
                    initiateDrillDownReport={isLoading}
                    loaderArray={9}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: '' }}
                    showUTCTime={true}
                />
                {(isLoading || loading) && (
                    <div className='d-flex justify-content-center w-100'>
                        <TinyLoader />
                    </div>
            )}
            </div>
            {!_.isEmpty(logsData) && logsData?.Items?.length ?
                <div className='f-14'>
                    <CustomPaginationSS
                        pageNo={logsData.currentPage}
                        pageSize={logsData.itemsPerPage || 10}
                        first={(Number(logsData.currentPage) === 1) ? true : false}
                        last={Math.ceil(logsData.totalElements / Number(logsData.itemsPerPage)) === (Number(logsData.currentPage)) ? true : false}
                        totalElements={logsData.totalElements}
                        totalPages={logsData.totalPages}
                        pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
                    />
                </div> : ""
            }
        </div>
    );
};

export default SmsMessageLog;